import { useParams, Navigate } from "react-router-dom";
import { useLanguage } from "../i18n/LanguageContext";
import { chiSiamo } from "../i18n/chisiamo";
import ContentPage from "../components/ContentPage";

export function ChiSiamo() {
  const { lang } = useLanguage();
  return <ContentPage content={chiSiamo[lang]} heroImage={chiSiamo[lang].heroImage} />;
}

export default function ServiceDetail() {
  const { slug } = useParams();
  const { t } = useLanguage();
  const detail = t.details[slug];
  const meta = t.services.find((s) => s.slug === slug);
  if (!detail || !meta) return <Navigate to="/servizi" replace />;
  return <ContentPage content={detail} heroImage={meta.image} />;
}

export function RiskAnalysis() {
  const { t } = useLanguage();
  return <ContentPage content={t.pages.risk} />;
}

export function Regulation() {
  const { t } = useLanguage();
  return <ContentPage content={t.pages.regulation} countdown />;
}

export function Industry() {
  const { t } = useLanguage();
  return <ContentPage content={t.pages.industry} />;
}

export function AIPage() {
  const { t } = useLanguage();
  return <ContentPage content={t.pages.ai} />;
}
